import * as React from 'react';
import Link from 'ha/ui/next/Link';
import withIntl from 'ha/i18n/withIntl';
import { IntlProps } from 'ha/i18n';
import { checkIfCityInSeoExperiment } from 'ha/utils/seoExperiment';

interface OwnProps {
  cityCanonical?: string;
  cityLocalizedName?: string;
  cityLink?: string;
  countryCanonical?: string;
  countryLocalizedName?: string;
  countryLink?: string;
}

type Props = OwnProps & IntlProps;

const SearchGuidesLinks: React.SFC<Props> = ({
  cityCanonical,
  cityLink,
  cityLocalizedName,
  countryCanonical,
  countryLink,
  countryLocalizedName,
  intl: { T },
}) => {
  if (!cityLink) {
    return null;
  }

  const isNofollow = checkIfCityInSeoExperiment(
    cityCanonical,
    countryCanonical,
  );

  return (
    <div>
      <span>{T('Learn about living in:')} </span>
      <span>
        <Link
          to={cityLink}
          kind="mint-underline"
          rel={isNofollow ? 'nofollow' : undefined}
        >
          {cityLocalizedName}
        </Link>
        {countryLink && (
          <span>
            {' '}
            {T('or')}{' '}
            <Link to={countryLink} kind="mint-underline">
              {countryLocalizedName}
            </Link>
          </span>
        )}
      </span>
    </div>
  );
};

export default withIntl(SearchGuidesLinks);
